import React from 'react';
import ReactDOM from 'react-dom';
import './styles/index.css';
import App from './App';
//import * as serviceWorker from './serviceWorker';
import ReactGA from "react-ga4";

//this is for testing we need to refactor this later
ReactGA.initialize( "G-3LE9PGVM7N");

ReactDOM.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
//serviceWorker.unregister();
